export const textExtensions: string[] = [
  ".doc",
  ".docx",
  ".odt",
  ".txt",
  ".csv",
  ".md",
  ".html",
  ".log",
  ".rtf",
];

export const imageExtensions: string[] = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".bmp",
  ".svg",
  ".raw",
  ".webp",
  ".ico",
];

export const zipExtensions: string[] = [
  ".zip",
  ".zipx",
  ".7z",
  ".rar",
  ".tar.gz",
  ".tgz",
  ".tar.bz2",
  ".tar.xz",
];
